import React, { useState, useRef } from 'react'
import useClickOutside from './useClickOutside'

const CustomDropdown = ({
  value,
  options = [],
  onChange,
  placeholder = 'Select option',
  className = ''
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)

  useClickOutside(dropdownRef, () => setIsOpen(false), isOpen)

  // Normalize options to { value, label }
  const normalizedOptions = options.map((opt) => {
    if (typeof opt === 'string') {
      let label = opt
      if (opt === 'Driving-Traffic' || opt === 'driving-traffic') {
        label = 'Driving with traffic'
      }
      return { value: opt, label }
    }
    return opt
  })

  const selectedOption = normalizedOptions.find((opt) => opt.value === value) ||
    normalizedOptions.find((opt) => opt.label === value) ||
    (value ? { value, label: value === 'Driving-Traffic' ? 'Driving with traffic' : value } : null)

  const handleSelect = (opt) => {
    if (typeof onChange === 'function') {
      onChange(opt.value)
    }
    setIsOpen(false)
  }

  return (
    <div ref={dropdownRef} className={`custom-dropdown ${isOpen ? 'is-open' : ''} ${className}`}>
      <button
        type='button'
        className='custom-dropdown__trigger'
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <span className='custom-dropdown__selected-text'>
          {selectedOption ? selectedOption.label : placeholder}
        </span>
        <svg
          className={`custom-dropdown__arrow ${isOpen ? 'is-rotated' : ''}`}
          width='14'
          height='14'
          viewBox='0 0 24 24'
          fill='none'
          stroke='#3D4058'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        >
          <polyline points='6 9 12 15 18 9' />
        </svg>
      </button>

      {isOpen && (
        <div className='custom-dropdown__menu'>
          {normalizedOptions.map((opt) => {
            const isSelected = selectedOption && selectedOption.value === opt.value
            return (
              <div
                key={opt.value}
                className={`custom-dropdown__item ${isSelected ? 'is-selected' : ''}`}
                onClick={() => handleSelect(opt)}
              >
                <span className='custom-dropdown__item-label'>{opt.label}</span>
                {isSelected && (
                  <svg
                    className='custom-dropdown__check'
                    width='16'
                    height='16'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='#2A7382'
                    strokeWidth='2.2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  >
                    <polyline points='20 6 9 17 4 12' />
                  </svg>
                )}
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default CustomDropdown
